<template>
  <n-modal class="card-company-invite" :loading="$var('loading')" @close="$emit('close')">
    <h3>Добавить сотрудника</h3>
    <n-form @submit="submit">
      <n-items>
        <n-input title="ИИН" v-bind="$form.input('iin')" />
        <n-input title="ФИО" v-bind="$form.input('fullName')" />
        <n-input title="E-mail" :danger="$var('mes')" v-bind="$form.input('email')" />
        <n-input title="Повторите e-mail" :danger="$var('mes')" v-bind="$form.input('email2')" />
        <n-button color="primary" wide type="submit">Отправить приглашение</n-button>
      </n-items>
    </n-form>
  </n-modal>
</template>

<script>
export default {
  name: 'CardCompanyInvite',
  props: [ 'companyId', ],
  created() {
    this.$form.init({
      iin: '',
      email: '',
      email2: '',
      fullName: '',
    })
    this.$var('mes', '')
  },
  methods: {
    submit() {
      if (this.$form.get('email') === this.$form.get('email2')) {
        this.$var('loading', true)
        $api.companies.workers.invite(this.companyId, this.$form.get()).then((response) => {
          this.$emit('submit')
          this.$emit('close')
        }).finally(() => {
          this.$var('loading', false)
        })
      } else {
        this.$var('mes', 'Адреса почты не сопадают')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .card-company-invite {
  }
</style>
